<template>
  <div class="lotti-stats-chart">
    <div class="lotti-stats-chart-title">{{title}}</div>
    <div class="lotti-stats-chart-bar">
      <!-- wrap purple with green elements and v-if based on condition to flip order-->
      <div v-if="percentBar2 === 100" class="lotti-stats-chart-bar-green" :style="'height: ' + percentBar2 + '%;'"></div>
      <div class="lotti-stats-chart-bar-purple" :style="'height: ' + percentBar1 + '%;'"></div>
      <div v-if="percentBar2 !== 100" class="lotti-stats-chart-bar-green" :style="'height: ' + percentBar2 + '%;'"></div>
    </div>
    <div class="lotti-stats-chart-time">{{minutes}} min</div>
  </div>
</template>

<script>
import {router} from '../../main.js';

export default {

  props: {
    title: String,
    minutes: Number,
    percentBar1: Number,
    percentBar2: Number,
  },

  data() {
    return {
     
    }
  },
  methods: {

  },
  mounted() {

  }
}

</script>